import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import BackArrow from "@catchy/assets/svgs/navigation-left-arrow.svg";
import { getBackHrefForStopType } from "@catchy/region-config";
import IconButton from "./IconButton";
const getFallbackHref = ({
  stopType,
  query,
  asPath
}) => {
  return query.stop_id && !asPath.includes("stop") ? `/stop/${query.stop_id}` : getBackHrefForStopType(stopType);
};
const hasPreviousHistoryEntry = () => {
  if (typeof window === "undefined") {
    return false;
  }
  if (window.history.length > 1) {
    return true;
  }
  return (window.history.state?.idx ?? 0) > 0;
};
const BackLink = t0 => {
  const $ = _c(12);
  const {
    onMap,
    onBack,
    stopType
  } = t0;
  const router = useRouter();
  const {
    query
  } = useRouter();
  const clickedRef = useRef(false);
  let t1;
  let t2;
  if ($[0] !== router.events) {
    t1 = () => {
      const resetClicked = () => {
        clickedRef.current = false;
      };
      router.events.on("routeChangeComplete", resetClicked);
      router.events.on("routeChangeError", resetClicked);
      return () => {
        router.events.off("routeChangeComplete", resetClicked);
        router.events.off("routeChangeError", resetClicked);
      };
    };
    t2 = [router.events];
    $[0] = router.events;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onBack || $[4] !== query || $[5] !== router || $[6] !== stopType) {
    t3 = function handleGoBack() {
      if (clickedRef.current) {
        return;
      }
      clickedRef.current = true;
      if (onBack) {
        onBack();
        return;
      }
      const isInitialLoad = typeof window !== "undefined" && sessionStorage.getItem("isInitialLoad") === "true";
      const fallbackHref = getFallbackHref({
        stopType,
        query,
        asPath: router.asPath
      });
      if (isInitialLoad || !hasPreviousHistoryEntry()) {
        router.push(fallbackHref);
      } else {
        router.back();
      }
    };
    $[3] = onBack;
    $[4] = query;
    $[5] = router;
    $[6] = stopType;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleGoBack = t3;
  const t4 = onMap ? "map" : "default";
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BackArrow className="h-6 w-6" aria-hidden="true" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleGoBack || $[10] !== t4) {
    t6 = <IconButton label="Back" variant={t4} onClick={handleGoBack}>{t5}</IconButton>;
    $[9] = handleGoBack;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default BackLink;